import { ReactElement } from 'react';

import { Dropdown } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';

type RemoveEntryDropdownItemProps = {
   onClick: VoidFunction;
   disabled: boolean;
};

export const RemoveEntryDropdownItem = (props: RemoveEntryDropdownItemProps): ReactElement => {
   return (
      <Dropdown.Item
         testId={'removeEntry'}
         onClick={(hide) => {
            props.onClick();
            hide();
         }}
         disabled={props.disabled}
      >
         <Translate>{translationKeys.removeEntry}</Translate>
      </Dropdown.Item>
   );
};
